import type { EventBasedMarketView } from '@ps/isp-web-services-types';
import { MarketStatus } from '@ps/isp-web-services-types';
import produce from 'immer';
import type { Draft } from 'immer';

import type { MarketPollingData } from '@swf/sports/types/market';
import updateMarket from '@swf/sports/utils/updateMarket';

import { defaultState } from './defaultState';
import type { InPlayMarketTemplatesView } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  dataLoadFailed: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    error: payload
  }),
  dataLoadSuccess: (state: State, payload: InPlayMarketTemplatesView): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    ...payload
  }),
  inPlayEventsRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  tabChange: (state: State): State => ({
    ...defaultState,
    tabs: state.tabs
  }),
  marketsUpdated: (state: State, { data, closed }: MarketPollingData): State =>
    produce(state, (draft) => {
      (Object.values(draft.markets) as Draft<EventBasedMarketView>[]).forEach((market) => {
        if (closed.includes(market.marketId)) {
          market.marketStatus = MarketStatus.CLOSED;
          return;
        }

        const marketUpdate = data[market.marketId];

        if (marketUpdate) updateMarket(market, marketUpdate);
      });

      return draft;
    })
};
